import React, { useMemo } from "react";
import { FilterLabelButton, Dropdown, DropdownMenu } from "@toddle-edu/ds-web";
import { useI18n } from "Hooks";
import { DUAL_PANEL_VIEW } from "AppComponents/DualPanelManageMembersV2/module/utils";

const ViewModeFilter = ({ typeFilter, setTypeFilter, filterOptions }) => {
  const { t } = useI18n(["common"]);

  const optionsSource = filterOptions || DUAL_PANEL_VIEW;

  const optionsForDropdown = useMemo(
    () =>
      Object.values(optionsSource).map(mode => ({
        key: mode.key,
        label: t(mode.labelKey),
      })),
    [optionsSource]
  );

  const onDropdownItemClick = e => setTypeFilter(e.key);

  const labelValue = optionsSource[typeFilter]
    ? t(optionsSource[typeFilter].labelKey)
    : undefined;

  const overlay = (
    <DropdownMenu
      dsVersion="2.0"
      options={optionsForDropdown}
      onClick={onDropdownItemClick}
      showSelection
      selectionType="radio"
      value={typeFilter}
    />
  );

  return (
    <Dropdown overlay={overlay}>
      <FilterLabelButton
        dsVersion="2.0"
        label={t("common:view")}
        labelValue={labelValue}
        type="outlined"
      />
    </Dropdown>
  );
};

export default ViewModeFilter;
